import * as React from 'react';

import {Popover} from 'shells/popover/popover';

import {AiUsagePopoverContent} from '../power-ai/power-ai-usage-popover/ai-usage-popover-content';

type Props = {
    anchor: {
        current: any;
    };
    isFirstTranscription: boolean;
    onConfirm: () => void;
};

export function TranscribeInfoPopover(props: Props) {
    return (
        <Popover
            location='top-left'
            anchor={props.anchor.current}
            overlayStyles={{display: 'none'}}
        >
            {props.isFirstTranscription ? (
                <AiUsagePopoverContent
                    title='Let Nutshell do the typing'
                    body='Use Notetaker to assist you in transcribing messages. Tap the button, start speaking your notes, and Nutshell will do the typing.'
                    monthlyUsage={null}
                    shouldShowBillingLink={false}
                    isTooltip={false}
                    acknowledgment={{
                        onClick: props.onConfirm,
                    }}
                />
            ) : null}
        </Popover>
    );
}
